var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "form", staticClass: "w-full" },
    [
      _c(
        "ValidationObserver",
        {
          ref: "observer",
          staticClass: "flex flex-col md:flex-row w-full md:items-center",
          attrs: { tag: "form" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit("/api/subscribe")
            },
          },
        },
        [
          _c("ValidationProvider", {
            ref: "email",
            attrs: {
              vid: "email",
              rules: "required|email",
              name: _vm.bundledTranslations.email,
              slim: true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "w-full sm:translate-y-[8px]",
                        class: props.classes,
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.formData.email,
                              expression: "formData.email",
                            },
                          ],
                          staticClass: "form__input form__input--underline",
                          attrs: {
                            type: "email",
                            name: "email",
                            placeholder:
                              _vm.bundledTranslations.email_placeholder,
                          },
                          domProps: { value: _vm.formData.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.formData,
                                "email",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "mt-sm justify-center md:mt-0 md:ml-sm flex-shrink-0 btn btn--outline btn--primary",
              attrs: { type: "submit" },
            },
            [
              _vm._v("\n            Inschrijven\n            "),
              _c("i", { staticClass: "fa-light fa-arrow-right" }),
            ]
          ),
          _vm._v(" "),
          _vm.compiledErrors && _vm.compiledErrors.length
            ? _c(
                "span",
                {
                  staticClass:
                    "error text-red text-xs leading-none inline-block mb-5",
                },
                [_vm._v(_vm._s(_vm.compiledErrors[0]))]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.emailErrors && _vm.emailErrors.length
        ? _c(
            "span",
            { staticClass: "text-red text-xs leading-none inline-block" },
            [_vm._v(_vm._s(_vm.emailErrors[0]))]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }